import {
  getYear,
  getMonth,
  getDate,
  setYear,
  setMonth,
  setDate
} from 'date-fns'

export default {
  birthDay: (state) => {
    let date = new Date()
    date = setYear(date, state.birthDayYear)
    date = setMonth(date, state.birthDayMonth - 1)
    date = setDate(date, state.birthDayDate)
    return date
  },

  splitBirthDay: (state) => {
    const birthDay = state.user.get('birthDay')
    return [ getYear(birthDay), getMonth(birthDay) + 1, getDate(birthDay) ]
  }
}
